
export enum UserNotificationSettingsLayer {
  User = 'user',
  Site = 'site',
  Server = 'server'
}
